GoogleMapService.$inject = ['$window', '$q'];

export function GoogleMapService($window, $q) {
  var googleMapApiKey = 'AIzaSyCndqv9f5_EE2f07WT7azTRBjy_8zvf32g'; // Settings for every account or company

  // Google's url for async maps initialization accepting callback function
  // var asyncUrl = 'https://maps.googleapis.com/maps/api/js?libraries=places&callback=',
  var asyncUrl =
      'https://maps.googleapis.com/maps/api/js?key=' +
      googleMapApiKey +
      '&libraries=places&callback=',
    deferred = $q.defer();

  //Callback function - resolving promise after maps successfully loaded
  $window.googleMapsInitialized = deferred.resolve;

  // async loader
  var asyncLoad = function (asyncUrl, callbackName) {
    var script = document.createElement('script');
    //script.type = 'text/javascript';
    script.src = asyncUrl + callbackName;
    document.body.appendChild(script);
  };

  // Start loading google maps
  asyncLoad(asyncUrl, 'googleMapsInitialized');

  // Usage: GoogleMapService.loadGoogleMapScript.then(callback)
  return {
    loadGoogleMapScript: deferred.promise,
  };
}
